export class GlobalEventDistributor {
  constructor() {
    this.stores = [];
    this.storeDataMapping = {};
  }

  registerStore(store) {
    this.stores.push(store);
  }

  emit(event, data) {
    this.stores.forEach((s) => {
      if (data && data.name && data.name === 'isNavCollapsed') {
        this.storeDataMapping[data.name] = data.value;
      }
      let value = undefined;
      if (data && data.name && data.value) value = data.value;
      return s.emit(event, value)
    });
  }
}